<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isUser()"> -->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Manage Trip</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
			<br>
			<div class="col-md-12">
				<div class="card card-primary card-outline">
					<div class="card-body">
						<p>Delivery Partner: {{trip.delivery_partner.name}}</p>
						<p>{{trip.delivery_partner.address_line_1}}, {{trip.delivery_partner.address_line_2}}, {{trip.delivery_partner.address_line_3}}, {{trip.delivery_partner.city}}, {{trip.delivery_partner.state}}, {{trip.delivery_partner.country}}, {{trip.delivery_partner.pincode}}</p>
						<p>Contact: {{trip.delivery_partner.email}}, {{trip.delivery_partner.phone}}</p>
					</div>
					<div class="card-body">
						<p>Driver: {{trip.delivery_driver.lead_profile.name}}</p>
						<p>Contact: {{trip.delivery_driver.lead_profile.email}}, {{trip.delivery_driver.lead_profile.mobile}}</p>
					</div>
					<div class="card-body">
						<p>Vehicle: {{trip.delivery_vehicle.year}} {{trip.delivery_vehicle.color}} {{trip.delivery_vehicle.model}} {{trip.delivery_vehicle.make}} {{trip.delivery_vehicle.type}}</p>
						<p>Reg. No.: {{trip.delivery_vehicle.reg_no}}, Permit: {{trip.delivery_vehicle.permit_type}}, Capacity: {{trip.delivery_vehicle.weight_capacity}}</p>
					</div>
				</div>
			</div>
			<div class="col-md-12">
				<div class="col-md-6">
					<div class="row">
						<div class="form-group">
							<button class="btn btn-primary" @click="addDeliveryPrompt" v-if="trip.status == 'Created' || trip.status == 'Re Scheduled'">Add Delivery Item to Trip</button>
						</div>
						<div class="form-group">
							<button class="btn btn-primary" @click="addTransferPrompt" v-if="trip.status == 'Created' || trip.status == 'Re Scheduled'">Add Stock Transfer to Trip</button>
						</div>
						<div class="form-group">
							<button class="btn btn-success" @click="letsGo" v-if="trip.status == 'Created' || trip.status == 'Re Scheduled'">Start Trip</button>
						</div>
						<div class="form-group">
							<button class="btn btn-success" @click="reSchedulePrompt" v-if="trip.status == 'En Route'">Re Schedule Trip</button>
						</div>
					</div>
				</div>
				<div class="col-md-12">
					<table class="table table-hover table-striped table-bordered">
						<thead>
							<tr>
								<th scope="col">Item</th>
								<th scope="col">Notes</th>
								<th scope="col">Status</th>
								<th scope="col">Manage</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="i in list">
								<td v-if="i.deliveries_id != null">
									<p>Invoice Delivery:</p>
									<p>SAP Doc Entry: {{i.delivery.order.sap_doc_entry}}</p>
									<p>SAP Doc Num: {{i.delivery.order.sap_doc_num}}</p>
									<p>Gatepass: {{i.delivery.order.gatepass_id}}</p>
									<p>Customer Name: {{i.delivery.order.customer_name}}</p>
									<p>Phone: {{i.delivery.order.stock_transfer_request}}</p>
								</td>
								<td v-else-if="i.stock_transfer_request_id">Stock Transfer: {{i.stock_transfer_request_id}}</td>
								<td>{{i.notes}}</td>
								<td>{{i.status}}</td>
								<td>
									<button class="btn btn-primary" v-if="i.deliveries_id != null" @click="viewDeliveryDetails(i.delivery.order.gatepass_id, i.delivery.order.id)">Details</button>
									<button class="btn btn-warning" @click="reScheduleItemPrompt(i)">Change Status</button>
									<button class="btn btn-success" @click="completePrompt(i)">Complete</button>
									<button class="btn btn-danger" @click="deletePrompt(i.id)">Delete</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
    </section>
    <!-- /.content -->

		<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" id="deliveryitemmodal" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
				  <div class="modal-body">
				  	<div class="form-group">
				  		<label>Select Item</label>
				  		<select class="form-control" v-model="transferitem">
				  			<option v-for="item in deliverylist" :value="item.id">
				  				{{item.order.doc_detail}}
				  			</option>
				  		</select>
				  	</div>
				  	<div class="form-group">
				  		<label>Note</label>
				  		<input type="text" v-model="notes" placeholder="Enter Notes" class="form-control">
				  	</div>
				  </div>
				  <div class="modal-footer">
				  	<button type="button" class="btn btn-primary" @click="addDeliveryItem">Add</button>
        		<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
				  </div>
				</div>
			</div>
		</div>
		
		<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" id="stitemmodal" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
				  <div class="modal-body">
				  	<div class="form-group">
				  		<label>Select Item</label>
				  		<select class="form-control" v-model="transferitem">
				  			<option v-for="item in stocktransferlist" :value="item.id">
				  				{{item.destination_branch}}/{{item.destination_warehouse}} <i class="fa fa-square-arrow-right"></i> {{item.source_branch}}/{{item.source_warehouse}}
				  			</option>
				  		</select>
				  	</div>
				  	<div class="form-group">
				  		<label>Note</label>
				  		<input type="text" v-model="notes" placeholder="Enter Notes" class="form-control">
				  	</div>
				  </div>
				  <div class="modal-footer">
				  	<button type="button" class="btn btn-primary" @click="addSTItem">Add</button>
        		<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
				  </div>
				</div>
			</div>
		</div>
		
		<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" id="reitemmodal" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h3>Change Status of Delivery Item</h3>
					</div>
				  <div class="modal-body">
				  	<div class="form-group">
							<v-select v-model="status" :options="deliverystatuses" label="status" :reduce="deliverystatuses => deliverystatuses.status"></v-select>
						</div>
				  	<div class="form-group">
				  		<label>Notes</label>
				  		<input type="text" v-model="notes" placeholder="Enter Notes" class="form-control">
				  	</div>
				  </div>
				  <div class="modal-footer">
				  	<button type="button" class="btn btn-primary" @click="reScheduleItem">Change</button>
        		<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
				  </div>
				</div>
			</div>
		</div>
		
		<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" id="completeitemmodal" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h3>Complete Delivery Item</h3>
					</div>
				  <div class="modal-body">
				  	<div class="form-group">
				  		<label>OTP</label>
				  		<input type="text" v-model="otp" placeholder="Enter OTP" class="form-control">
				  	</div>
				  	<div class="form-group">
				  		<label>Notes</label>
				  		<input type="text" v-model="notes" placeholder="Enter Notes" class="form-control">
				  	</div>
				  </div>
				  <div class="modal-footer">
				  	<button type="button" class="btn btn-success">Complete</button>
        		<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
				  </div>
				</div>
			</div>
		</div>
		
		<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" id="deleteitemmodal" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-body">
				  	<h1>Are you sure you want to delete the item?</h1>
				  </div>
				  <div class="modal-footer">
				  	<button type="button" class="btn btn-danger" @click="deleteItem">Delete</button>
        		<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
				  </div>
				</div>
			</div>
		</div>
		
		<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" id="remodal" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h3>Re Schedule Trip</h3>
					</div>
				  <div class="modal-body">
				  	<div class="form-group">
				  		<label>Start Date</label>
				  		<input type="date" class="form-control" v-model="start_date">
				  	</div>
				  	<div class="form-group">
				  		<label>End Date</label>
				  		<input type="date" class="form-control" v-model="end_date">
				  	</div>
				  	<div class="form-group">
				  		<label>Note</label>
				  		<input type="text" v-model="notes" placeholder="Enter Notes" class="form-control">
				  	</div>
				  </div>
				  <div class="modal-footer">
				  	<button type="button" class="btn btn-primary" @click="reScheduleTrip">Re Schedule</button>
        		<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
				  </div>
				</div>
			</div>
		</div>
    
<!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isUser()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        created(){
        	this.getTrip();
        	this.getDeliveryStatuses();
        },
        
        data(){
        	return{
        		deliverylist: [],
        		stocktransferlist: [],
        		list: [],
        		trip: {},
        		transferitem: '',
        		notes: '',
        		curr_id: '',
        		start_date: '',
        		end_date: '',
        		notes: '',
        		complete_id: '',
        		delete_id: '',
        		otp: '',
        		deliverystatuses: [],
        		status: ''
        	}
        },
        
        methods: {
        	getDeliveryStatuses(){
        		axios.post("/api/getDeliveryStatuses")
        		.then(response => {
        			this.deliverystatuses = response.data;
        		})
        	},
        	
        	getTrip(){
        		axios.post("/api/getDeliveryTrip", {id: this.$route.params.id})
        		.then(response => {
        			this.trip = response.data;
				    	this.getDeliveries();
				    	this.getStockTransfers();
				    	this.getList();
        		});
        	},
        	
        	getDeliveries(){
        		axios.post("/api/getUnassignedDeliveries")
        		.then(response => {
        			this.deliverylist = response.data;
        		});
        	},
        	
        	getStockTransfers(){
        		axios.post("/api/getDriverSTR", {vehicle_id: this.trip.vehicle_id, driver_id: this.trip.driver_id, dp_id: this.trip.dp_id})
        		.then(response => {
        			this.stocktransferlist = response.data;
        		});
        	},
        	
        	getList(){
        		axios.post("/api/getTripList", {trip: this.$route.params.id})
        		.then(response => {
        			this.list = response.data;
        		});
        	},
        	
        	addDeliveryPrompt(){$("#deliveryitemmodal").modal("show");},
        	
        	addTransferPrompt(){$("#stitemmodal").modal("show");},
        	
        	addDeliveryItem(){
        		var type = this.deliverylist.find(v => v.id === this.transferitem).order.customer_type;
        		axios.post("/api/addDeliveryToTrip", {trip: this.$route.params.id, delivery:this.transferitem, notes: this.notes, customer_type: type})
        		.then(response => {
        			if(response.data == 200){
		      			toast.fire({
		      				icon: 'success',
		      				title: 'Added'
		      			});
		      			this.getTrip();
		      		}
		      		else{
		      			toast.fire({
		      				icon: 'error',
		      				title: 'Failed! Item already in trip'
		      			});
		      		}
        		});
        	},
        	
        	addSTItem(){
        		axios.post("/api/addSTToTrip", {trip: this.$route.params.id, stocktransfer:this.transferitem, notes: this.notes})
        		.then(() => {
        			if(response.data == 200){
		      			toast.fire({
		      				icon: 'success',
		      				title: 'Added'
		      			});
		      			this.getTrip();
		      		}
		      		else{
		      			toast.fire({
		      				icon: 'error',
		      				title: 'Failed! Item already in trip'
		      			});
		      		}
        		});
        	},
        	
        	letsGo(){
        		axios.post("/api/vandiVittitond", {trip: this.$route.params.id})
        		.then(response => {
        			if(response.data == 200){
		      			toast.fire({
		      				icon: 'success',
		      				title: 'Started'
		      			});
		      			this.getTrip();
		      		}
		      		else{
		      			toast.fire({
		      				icon: 'error',
		      				title: 'Failed! Trip Already En Route'
		      			});
		      		}
        		})
        	},
        	
        	reScheduleItemPrompt(item){
        		this.curr_id = item.id;
        		$("#reitemmodal").modal("show");
        	},
        	
        	reScheduleItem(){
        		axios.post("/api/reScheduleTripItem", {id: this.curr_id, notes: this.notes, status: this.status})
        		.then(() => {
        			toast.fire({
        				icon: 'success',
        				title: 'Item Re Scheduled'
        			});
        			this.getTrip();
        		})
        	},
        	
        	reSchedulePrompt(){
        		$("#remodal").modal("show");
        	},
        	
        	reScheduleTrip(){
        		axios.post("/api/reScheduleTrip", {id: this.$route.params.id, start_date: this.start_date, end_date: this.end_date, notes: this.notes})
        		.then(response => {
        			if(response.data == 200){
		      			toast.fire({
		      				icon: 'success',
		      				title: 'Trip Re Scheduled'
		      			});
		      			this.getTrip();
		      		}
		      		else{
		      			toast.fire({
		      				icon: 'error',
		      				title: 'Failed'
		      			});
		      		}
        		})
        	},
        	
        	viewDeliveryDetails(gatepass, order){
        		this.$router.push('/delivery-details/'+gatepass+'/'+order);
        	},
        	
        	deletePrompt(item){
        		this.delete_id = item;
        		$("#deleteitemmodal").modal("show");
        	},
        	
        	deleteItem(){
        		axios.post("/api/deleteTripItem", {id: this.delete_id})
        		.then(() => {
        			$("#deleteitemmodal").modal("hide");
        			this.getTrip();
        		});
        	}
        }
    }
</script>
